import React, { lazy, Suspense } from 'react';
import styles from './styles/styles.module.scss';
import { StringConstantsMixin } from '../mixins/shared/string_constants_mixin'; // necessary for loadMoreContent
import TrailCompletedCard from '../../../../components/cards/TrailCompletedCard';
import TrailReviewResultCard from '../../../../components/cards/TrailReviewResultCard';
import { PhotosFeedItem, PhotosFeedFakeItem } from './photos_feed_item';
import { TracksFeedItem } from './tracks_feed_item';
import { TrailUgcBar } from './trail_ugc_bar';
import ShowMoreItems from '../../../../components/location/ShowMoreItems';
import { urlReformatPhotos } from '../../../../utils/lightbox_helpers';
import { inIframe } from '../../../../utils/trail_helpers';
import { ServerCommunicationUtil } from '../../../../utils/server_communication_util';
// lazy loaded components
const ReviewFormModal = lazy(() => import('../../../../components/forms/ReviewFormModal'));
const PhotoUploadModal = lazy(() => import('../../../../components/forms/PhotoUploadModal'));
const TrackUploadModal = lazy(() => import('../../../../components/forms/TrackUploadModal'));
const Lightbox = lazy(() => import('../../../../components/shared/Lightbox'));

const createReactClass = require('create-react-class');

const feedItemDivs = {
  reviews: (item, props, i, openTrailFormModal) => {
    return (
      <TrailReviewResultCard
        idx={i}
        key={item.id}
        review={item}
        userId={props.userId}
        adminUser={props.adminUser}
        includeTrailName={props.includeTrailName}
        onReviewDeleted={(data, trail) => {
          if (props.handleItemDelete) {
            props.handleItemDelete(data, 'reviews', trail);
          }
        }}
        updateReview={props.updateReview}
        openReviewFormModal={openTrailFormModal}
        locale={props.locale}
        currentUserId={props.currentUserId}
        context={{ languageRegionCode: props.locale }}
      />
    );
  },
  photos: (item, props, i, openLightbox) => {
    return (
      <PhotosFeedItem key={`photo-${item.id}`} idx={i} item={item} photoSize={props.photoSize} visible={props.visible} openLightbox={openLightbox} />
    );
  },
  photosFake: (props, i) => {
    return <PhotosFeedFakeItem key={`fakephoto-${i}`} idx={i} photoSize={props.photoSize} />;
  },
  tracks: (item, props, i) => {
    return (
      <TracksFeedItem
        idx={i}
        key={item.id}
        data={item}
        adminOrPendingOwner={props.adminOrPendingOwner}
        userId={props.userId}
        adminUser={props.adminUser}
        displayMetric={props.displayMetric}
        onTrackDeleted={(data, trail) => {
          if (props.handleItemDelete) {
            props.handleItemDelete(data, 'tracks', trail);
          }
        }}
        includeUserName={props.includeUserName}
        includeTrailName={props.includeTrailName}
        locale={props.locale}
        trailId={props.trailId}
        visible={props.visible}
      />
    );
  },
  completed: (item, props, i) => {
    return <TrailCompletedCard context={{ languageRegionCode: props.locale }} idx={i} key={`completed-${item.id}`} user={item} />;
  }
};

const emptyFeedStrings = {
  reviews: StringConstantsMixin.strings.SEARCH.NO_ONE_REVIEWED,
  photos: StringConstantsMixin.strings.SEARCH.NO_ONE_PHOTOS,
  tracks: StringConstantsMixin.strings.SEARCH.NO_ONE_RECORDED,
  completed: StringConstantsMixin.strings.SEARCH.NO_ONE_COMPLETED
};

const TrailActivityFeed = createReactClass({
  getInitialState() {
    return {
      pageCount: 1,
      loadingMore: false,
      lightboxOpen: false,
      startingPhotosIndex: null,
      defaultImage: null,
      activeTrailFormModal: null,
      trailFormProps: null
    };
  },
  componentWillReceiveProps(nextProps) {
    if (nextProps.sortOption !== this.props.sortOption) {
      this.setState({ pageCount: 1 });
    }
  },
  componentDidMount() {
    this.handleResize();
    window.addEventListener('resize', this.handleResize);
  },
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
  handleResize() {
    // prioritize mobile index
    let isMobileWidth = true;
    if (window) {
      isMobileWidth = window.innerWidth <= 767;
    }
    this.setState({ isMobileWidth });
  },

  // Code extracted from FeedPagingMixin
  addNextPage(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ loadingMore: true });
    const nextPage = this.state.pageCount + 1;
    if (this.props.locationServerData) {
      if (this.props.locationServerData.trail_id) {
        ServerCommunicationUtil.loadMoreContent(
          this.props.feedType,
          null,
          this.props.locationServerData.type,
          this.props.locationServerData.loc_id,
          nextPage,
          this.props.perPage,
          false,
          null,
          function(data) {
            this.setState({ pageCount: nextPage, loadingMore: false });
            this.props.loadMore(data, this.props.feedType);
          }.bind(this),
          false,
          this.props.sortOption,
          null,
          this.props.locale
        );
      } else if (
        this.props.locationServerData.featuredLocationType &&
        (this.props.locationServerData.featuredLocationType === 'parks' ||
          this.props.locationServerData.featuredLocationType === 'national-parks' ||
          this.props.locationServerData.featuredLocationType === 'state-parks' ||
          this.props.locationServerData.featuredLocationType === 'local-parks')
      ) {
        ServerCommunicationUtil.loadMoreContent(
          this.props.feedType,
          this.props.locationServerData.country_id,
          this.props.locationServerData.type,
          this.props.locationServerData.loc_id,
          nextPage,
          this.props.perPage,
          true,
          null,
          function(data) {
            this.setState({ pageCount: nextPage, loadingMore: false });
            this.props.loadMore(data, this.props.feedType);
          }.bind(this),
          true,
          this.props.sortOption,
          this.props.locationServerData.park_type,
          this.props.locale
        );
      } else if (this.props.locationServerData.list_id) {
        ServerCommunicationUtil.loadMoreContent(
          this.props.feedType,
          null,
          this.props.locationServerData.type,
          this.props.locationServerData.list_id,
          nextPage,
          this.props.perPage,
          false,
          null,
          function(data) {
            this.setState({ pageCount: nextPage, loadingMore: false });
            this.props.loadMore(data, this.props.feedType);
          }.bind(this),
          false,
          this.props.sortOption,
          null,
          this.props.locale
        );
      } else {
        ServerCommunicationUtil.loadMoreContent(
          this.props.feedType,
          this.props.locationServerData.country_id,
          this.props.locationServerData.type,
          this.props.locationServerData.loc_id,
          nextPage,
          this.props.perPage,
          true,
          this.props.locationServerData.attribute,
          function(data) {
            this.setState({ pageCount: nextPage, loadingMore: false });
            this.props.loadMore(data, this.props.feedType);
          }.bind(this),
          false,
          this.props.sortOption,
          null,
          this.props.locale
        );
      }
    } else {
      // loading from user reviews page
      ServerCommunicationUtil.loadMoreContent(
        this.props.feedType,
        null,
        'users',
        this.props.userId,
        nextPage,
        this.props.perPage,
        true,
        null,
        function(data) {
          this.setState({ pageCount: nextPage, loadingMore: false });
          this.props.loadMore(data, this.props.feedType);
        }.bind(this),
        false,
        this.props.sortOption,
        null,
        this.props.locale
      );
    }
    return false;
  },

  getLightboxProps(startingPhotosIndex) {
    return {
      images: urlReformatPhotos(this.props.items),
      handleCloseRequest: this.handleCloseRequest,
      isOpen: true,
      startingIndex: startingPhotosIndex,
      trailId: this.props.trailId
    };
  },
  openLightbox(startingPhotosIndex) {
    // if this is being rendered out of an iFrame
    if (inIframe()) {
      const data = this.getLightboxProps(startingPhotosIndex);
      const event = new CustomEvent('toggleModal', { detail: data });
      window.parent.document.dispatchEvent(event);
    } else {
      this.setState({ lightboxOpen: true, startingPhotosIndex });
    }
  },
  handleCloseRequest() {
    this.setState({ lightboxOpen: false, startingPhotosIndex: null });
  },
  appendFakeItems(feedItems) {
    const feedType = this.props.feedType;
    // Add fake photo items to bottom of flex box grid to align items properly (otherwise last items have giant space between them)
    if (feedType === 'photos') {
      const { isMobileWidth } = this.state;
      const mod7 = feedItems.length % 7;
      let numFakeItemsNeeded = 0;
      if (isMobileWidth) {
        if ([1, 3].includes(mod7)) {
          numFakeItemsNeeded = 1;
        }
      } else if ([1, 2, 3].includes(mod7)) {
        numFakeItemsNeeded = 4 - mod7;
      } else if ([5, 6].includes(mod7)) {
        numFakeItemsNeeded = 7 - mod7;
      }
      for (let i = 0; i < numFakeItemsNeeded; i++) {
        feedItems.push(feedItemDivs[`${feedType}Fake`](this.props, i));
      }
    }
  },
  openTrailFormModal(activeTrailFormModal, trailFormProps) {
    // this is where we should be making the call if it's in explore
    if (inIframe()) {
      const event = new CustomEvent('openTrailFormModal', {
        detail: { activeTrailFormModal, trailFormProps: { ...trailFormProps, exploreFlag: true } }
      });
      window.parent.document.dispatchEvent(event);
    } else {
      this.setState({ activeTrailFormModal, trailFormProps });
    }
  },
  closeActiveTrailFormModal() {
    this.setState({ activeTrailFormModal: null, trailFormProps: null });
  },
  renderLightBox() {
    if (this.props.feedType !== 'photos' || !this.state.lightboxOpen) {
      return null;
    }

    return (
      <Suspense fallback={null}>
        <Lightbox {...this.getLightboxProps(this.state.startingPhotosIndex)} />
      </Suspense>
    );
  },
  renderTrailFormModal() {
    if (!this.state.activeTrailFormModal) {
      return;
    }

    switch (this.state.activeTrailFormModal) {
      case 'reviews':
        return (
          <Suspense fallback={null}>
            <ReviewFormModal
              {...this.state.trailFormProps}
              closeReviewModal={this.closeActiveTrailFormModal}
              onReviewAdd={this.props.onReviewAdd}
              updateReview={this.props.updateReview}
              isMobile={this.props.mobileBrowser}
              locale={this.props.locale}
            />
          </Suspense>
        );
      case 'photos':
        return (
          <Suspense fallback={null}>
            <PhotoUploadModal {...this.state.trailFormProps} closePhotoModal={this.closeActiveTrailFormModal} onPhotosAdd={this.props.onPhotosAdd} />
          </Suspense>
        );
      case 'tracks':
        return (
          <Suspense fallback={null}>
            <TrackUploadModal
              {...this.state.trailFormProps}
              closeActiveTrailModal={this.closeActiveTrailFormModal}
              onTrackAdd={this.props.onTrackAdd}
              locale={this.props.locale}
            />
          </Suspense>
        );
      default:
        return null;
    }
  },
  renderFeedItems() {
    let feedItems;
    const feedType = this.props.feedType;
    if (this.props.items.length < 1) {
      return <p className="no-message rounded">{emptyFeedStrings[feedType]}</p>;
    }

    if (feedType === 'photos') {
      feedItems = this.props.items.map((item, i) => feedItemDivs[feedType](item, this.props, i, this.openLightbox));
    } else if (feedType === 'reviews') {
      feedItems = this.props.items.map((item, i) => feedItemDivs[feedType](item, this.props, i, this.openTrailFormModal));
    } else {
      feedItems = this.props.items.map((item, i) => {
        return feedItemDivs[feedType](item, this.props, i);
      });
    }

    this.appendFakeItems(feedItems);
    return feedItems;
  },
  feedClasses() {
    if (this.props.feedType === 'completed') {
      return styles.twoColumns;
    }
    return null;
  },
  renderFeedTabHeader() {
    return (
      <TrailUgcBar
        activeTab={this.props.feedType}
        completedConnectionId={this.props.completedConnectionId}
        currentUserId={this.props.currentUserId}
        exploreFlag={this.props.exploreFlag}
        handleCompletedConnectionChanged={this.props.handleCompletedConnectionChanged}
        items={this.props.items}
        itemCount={this.props.maxItems}
        loadMore={this.props.loadMore}
        locale={this.props.locale}
        loggedInUserId={this.props.userId}
        messagingChannel={this.props.messagingChannel}
        modalSigninPath={this.props.modalSigninPath}
        ratingsBreakdown={this.props.ratingsBreakdown}
        shouldReload={this.props.shouldReload}
        trailId={this.props.trailId}
        trailName={this.props.trailName}
        ugcSortDropDown={this.props.ugcSortDropDown}
        showContributeButton={this.props.showContributeButton}
        showInvitation={this.props.showInvitation}
        openTrailFormModal={this.openTrailFormModal}
      />
    );
  },
  render() {
    let customStyle = {};
    if (!this.props.visible) {
      customStyle = { display: 'none' };
    }
    return (
      <div id={this.props.feedType} style={customStyle}>
        <div className="feed-tab-header">{this.renderFeedTabHeader()}</div>
        <div className={`feed-items ${this.feedClasses()}`}>{this.renderFeedItems()}</div>
        <ShowMoreItems
          title={
            this.state.loading
              ? StringConstantsMixin.strings.SEARCH.LOADING
              : StringConstantsMixin.strings.SEARCH[`SHOW_MORE_${this.props.feedType.toUpperCase()}`]
          }
          config={{
            whiteBackground: true,
            min: 1,
            max: this.props.items.length,
            total: this.props.maxItems
          }}
          handler={this.addNextPage}
        />
        {this.renderLightBox()}
        {this.renderTrailFormModal()}
      </div>
    );
  }
});

export { TrailActivityFeed };
